import { combineReducers } from "redux";
import { reducer as oidc } from "redux-oidc";
import { auth } from "./auth/reducer";
import { configuracao } from "./configuracao/reducer";
import { licenciamentourbano } from "./licenciamentourbano/reducer";
import { mapa } from "./mapa/reducer";
import { servicos } from "./servicos/reducer";
import { zoonose } from "./zoonose/reducer";
import { identidade } from "./identidade/reducer";
import { consultaprevia } from "./consultaprevia/reducer";
import { ouvidoria } from "./ouvidoria/reducer";

const rootReducer = combineReducers({
  oidc,
  auth,
  mapa,
  configuracao,
  zoonose,
  licenciamentourbano,
  servicos,
  identidade,
  consultaprevia,
  ouvidoria
});
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
